'use client';
import { FaArrowUp } from 'react-icons/fa6';

export default function ScrollToTop() {
  const scrollTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  };
  return (
    <button
      aria-label='Back to top of the page'
      onClick={scrollTop}
      className='size-8 rounded-full bg-[#FF6600] text-white flex flex-col items-center justify-center absolute right-8 -top-4 z-999'
    >
      <FaArrowUp />
    </button>
  );
}
